<template>
  <div>
    <div class="card-body">
      <!-- Conversations are loaded here -->
      <div id="chatContainer" class="direct-chat-messages" style="height: 405px !important;">
        <!-- Message. Default to the left -->
        <div class="direct-chat-msg" v-for="message in messages" :class="{right: message.userId === GetCurrentUserFn().userId}">
          <div class="direct-chat-infos clearfix">
            <span class="direct-chat-name" :class="{'float-right': message.userId === GetCurrentUserFn().userId, 'float-left': message.userId !== GetCurrentUserFn().userId}">{{message.isSender === true ? guestName : message.user.userName}}</span>
            <span class="direct-chat-timestamp" :class="{'float-left': message.userId === GetCurrentUserFn().userId, 'float-right': message.userId !== GetCurrentUserFn().userId}">{{message.messageDateTime | moment('DD MMM hh:mm A')}}</span>
          </div>
          <!-- /.direct-chat-infos -->
          <!--<img class="direct-chat-img" src="static/assets/img/user1-128x128.jpg" alt="Message User Image">-->
          <b-avatar class="direct-chat-img" size="sm">{{message.isSender === true ? getFirstLetter(guestName) : getFirstLetter(message.user.userName)}}</b-avatar>
          <!-- /.direct-chat-img -->
          <div class="direct-chat-text">
            {{message.messageText}}
          </div>
          <!-- /.direct-chat-text -->
        </div>
        <!-- /.direct-chat-msg -->
        <!--<div class="spinner-grow spinner-grow-xs text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow spinner-grow-xs text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow spinner-grow-xs text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow spinner-grow-xs text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>-->

        <div>

          <!--<small class="text-muted">Rowllens is typing.....</small>-->
          <!--<span class="spinner-grow spinner-grow-xs text-secondary" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-xs text-secondary" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-xs text-secondary" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-xs text-secondary" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-xs text-secondary" role="status" aria-hidden="true"></span>-->
        </div>
      </div>

      <!--/.direct-chat-messages-->
    </div>
    <div class="card-footer">
      <div class="input-group">
        <input v-on:keyup.enter="addMessage" @click="focus()" type="text" v-model="message.messageText" name="message" placeholder="Type Message ..." class="form-control">
        <span class="input-group-append">
          <button @click="addMessage" class="btn btn-primary">Send</button>
        </span>
      </div>
    </div>


  </div>
</template>

<script>

  import ChatApi from '../../api/chat-api.js';
  import pmsHub from '../../store/modules/pms-hub';

  import { mapGetters } from 'vuex';


  export default {
    props: {
      roomStayGuestId: {
        type: Number,
        required: true
      },
      guestName: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        messages: null,
        message: {
          messageText: '',
          isSender: false,
          staffId: 0,
          messageDateTime: new Date(),
          isRead: true,
          propertyId: 0
        }
      }
    },
    methods: {
      focus() {
        pmsHub.client.invoke('MarkRead', this.roomStayGuestId, this.GetActiveLocationFn().pvid, `${this.GetActiveLocationFn().name}messages`);
      },
      getGuestMessages: async function () {
        try {
          let res = await ChatApi.GetGuestMessages(this.roomStayGuestId);

          this.messages = res.data.data;

        } catch (ex) {
          // console.log(ex);
        }
      },
      addMessage: async function () {
        try {

          if (!this.message.messageText)
            return;

          this.message.staffId = this.GetCurrentUserFn().userId;
          this.message.roomStayGuestId = this.roomStayGuestId;
          this.message.propertyId = this.GetActiveLocationFn().pvid;
          let res = await ChatApi.Create(this.message);

          this.message.messageText = '';

        } catch (ex) {
          // console.log(ex);
        }
      },
      scrollToBottom: function () {
        const container = this.$el.querySelector("#chatContainer");
        container.scrollTop = container.scrollHeight;
      },
      getFirstLetter: function (value) {
        return value.charAt(0).toUpperCase();
      }
    },
    mounted: async function () {

      await this.getGuestMessages();

      const self = this;

      pmsHub.client.invoke('JoinGroupRoom', `room${this.roomStayGuestId}`, '');

      pmsHub.client.on("SendMessage", function (data) {
        self.messages.push(data);
      });

      this.scrollToBottom();
    },
    computed: {
      ...mapGetters(['GetCurrentUserFn', 'GetActiveLocationFn']),
    }
  }
</script>

<style>
  .spinner-grow-xs {
    width: .5rem;
    height: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/chatBox.vue